import { FlatItem, PagedList } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';
import { IProposalType, ProposalTypeAdd, ProposalTypeMutation } from 'src/types/service_desk/proposalType.type';

const controller = 'service-desk/proposal-types';

export const getProposalTypesDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};

export const getProposalTypes = async (page: number, pageSize: number, orderBy?: string, searchCondition?: string) => {
  return await http.get<PagedList<IProposalType>>(`${controller}`, {
    params: {
      page,
      pageSize,
      orderBy,
      searchCondition
    }
  });
};

export const getProposalType = async (id: number) => {
  return http.get<IProposalType>(`${controller}/${id}`);
};

export const addProposalType = async (proposalType: ProposalTypeAdd) => {
  return http.post<IProposalType>(controller, proposalType);
};

export const updateProposalType = async (id: number, proposalType: ProposalTypeMutation) => {
  return await http.put<IProposalType>(`${controller}/${id}`, proposalType);
};

export const deleteProposalType = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};
